import { Action } from '@interstate/components/Action';
import { Grid } from '@interstate/components/Grid';
import { Popover } from '@interstate/components/Popover';
import { Typography } from '@interstate/components/Typography';
import { ProfitInfo } from '@makemydeal/dr-dash-components';
import { useMediaQuery } from 'react-responsive';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { useSelector } from 'react-redux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

export const useProfitDetailsVisibility = () => {
    const isDealRecapTabEnabled = useSelector(featureToggleSelectors.useDealRecapEnabled);
    const isTabletScreenSize = useMediaQuery({ query: `(max-width: ${BreakPoint.MEDIUM})` });

    const shown = !isDealRecapTabEnabled || isTabletScreenSize;

    return { shown };
};

export const ProfitDetails = () => (
    <Grid
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column'
        }}
    >
        <Typography sx={{ marginBottom: '0.714rem' }} variant="label-sm" color="sem.color.on-surface.muted">
            Recap
        </Typography>
        <Popover
            padding={true}
            header="Profit Details"
            data-testid="profit-details-popover"
            position="right-start"
            trigger="outsideClick"
            popoverContent={<ProfitInfo />}
        >
            <Action data-testid="profit-details-btn" size="sm">
                Details
            </Action>
        </Popover>
    </Grid>
);
